// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import MachineStatusInfo from './machine-status-info';
import PipStatus from '../../../../product/shared/components/pip-status';
import SecureFooter from '../../../shared/components/secure-footer';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';

function handleApproval() {

    this.openUpdateStatusChangeModal(this.item, 'APPROVE');

}

function handleDenial() {

    this.openUpdateStatusChangeModal(this.item, 'DENY');

}

function handleReturn() {

    this.openUpdateStatusChangeModal(this.item, 'RETURNED');

}
const MachineStatusUpdatesListItem = props =>
    <section className='machine-status-updates-list-item'>
        <main>
            <div className='product-header'>
                <Link
                    className='product-title'
                    rel='noopener noreferrer'
                    target='_blank'
                    to={`/products/${props.item.product.pin}`}
                >
                    {props.item.product.pin}
                </Link>
                <span className='machine-new-status'>{props.item.newStatus.value}</span>
                <span className='pip-status-container'>
                    {props.item.product.pipIndicator.status &&
                        <PipStatus
                            pin={props.item.product.pin}
                            pipIndicator={props.item.product.pipIndicator}
                        />
                    }
                </span>
            </div>
            <MachineStatusInfo statusChangeObject={props.item}/>
        </main>
        <SecureFooter
            isShowReturnButton={true}
            onApprove={props::handleApproval}
            onDeny={props::handleDenial}
            onReturn={props::handleReturn}
            securityFeature='TCSM_MACHINE_STATUS_PROCESS'
            securityModule='TCSM'
        />
    </section>;

MachineStatusUpdatesListItem.displayName = 'MachineStatusUpdatesListItem';
MachineStatusUpdatesListItem.propTypes = {
    item: PropTypes.instanceOf(StatusChange).isRequired,
    openUpdateStatusChangeModal: PropTypes.func.isRequired
};

export default MachineStatusUpdatesListItem;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/machine-status-updates/machine-status-updates-list-item.js